import { render } from "./ChangedAfterExportIcon.vue?vue&type=template&id=9d8e9e96&scoped=true"
import script from "./ChangedAfterExportIcon.vue?vue&type=script&lang=js"
export * from "./ChangedAfterExportIcon.vue?vue&type=script&lang=js"

import "./ChangedAfterExportIcon.vue?vue&type=style&index=0&id=9d8e9e96&scoped=true&lang=css"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d8e9e96"]])

export default __exports__